import { bindActionCreators } from 'redux';

export const SEND_NEW_PASS = 'PASS_RESTORE/SEND_NEW_PASS';

export const AdmiPassRestore = pass => ({
  type: SEND_NEW_PASS,
  payload: { pass }
});

function containerActions(dispatch) {
  return bindActionCreators(
    {
      AdmiPassRestore
    },
    dispatch
  );
}

export default containerActions;



// WEBPACK FOOTER //
// ./src/pages/AdminRestorePass/actions.js